export default "__VITE_PUBLIC_ASSET__6718b27f__"